import React from "react";

import { AccountTable } from "@components/Screen/AccountTable";
import { url_reverse } from "@components/Utils";

export default function Accounts({ developerId, header }) {
    const apiUrl = url_reverse("api:developer:account:list", { developer_id: developerId });
    return <AccountTable apiUrl={apiUrl} header={header} />;
}
